export default __webpack_public_path__ + "static/media/Kids CPR with breaths.45833355.jpg";